export default __webpack_public_path__ + "static/media/Duplicate_Screen.4feda3ce.svg";